import React from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminLearningMenu,
  LearningMatrixNav,
} from "../../../../components/AdminComponents/MenuItems";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { useSelector } from "react-redux";
import {
  Pagination,
  //  Popover,
  Table,
  //    Tag
} from "antd";
import { remainingViewportHeight } from "../../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";

const LearnerMatrix = () => {
  const userInfo = useSelector((state) => state.user);
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // handleSwitchChange,
    // setFilterData,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 15,
    passPage: 1,
    passURL: `learn/employeematrix/?organization_id=${userInfo.data.organization.id}`,
    // loadAgain: loadAgain,
    // includeStatus: false,
  });
  const { pageSize, currentPage } = filterData;
  const transformedData = data.flatMap((user) =>
    user.work_role.flatMap((role) =>
      role.course.map((course) => ({
        key: `${user.user_id}-${role.id}-${course.id}`,
        user_id: user.user_id,
        first_name: user.first_name,
        last_name: user.last_name,
        role_id: role.role_id,
        role_name: role.name,
        course_id: course.course_id,
        course_name: course.name,
      }))
    )
  );

  const columns = [
    {
      title: "User ID",
      dataIndex: "user_id",
      width: 120,
      render: (val, row, index) => {
        const sameUserRows = transformedData.filter(
          (item) => item.user_id === row.user_id
        );

        const firstIndex = transformedData.findIndex(
          (item) => item.user_id === row.user_id
        );

        return {
          children: <span className="text-primary">{val}</span>,
          props: {
            rowSpan: index === firstIndex ? sameUserRows.length : 0,
          },
        };
      },
    },
    {
      title: "User Name",
      width: 170,
      render: (_, row, index) => {
        const sameUserRows = transformedData.filter(
          (item) => item.user_id === row.user_id
        );
        const firstIndex = transformedData.findIndex(
          (item) => item.user_id === row.user_id
        );

        return {
          children: (
            <div className="text-truncate">
              {row.first_name} {row.last_name}
            </div>
          ),
          props: {
            rowSpan: index === firstIndex ? sameUserRows.length : 0,
          },
        };
      },
    },
    {
      title: "Work Role ID",
      dataIndex: "role_id",
      width: 120,
      render: (val, row, index) => {
        const sameRoleRows = transformedData.filter(
          (item) => item.role_id === row.role_id && item.user_id === row.user_id
        );

        const firstIndex = transformedData.findIndex(
          (item) => item.role_id === row.role_id && item.user_id === row.user_id
        );

        return {
          children: <span className="text-primary">{val}</span>,
          props: {
            rowSpan: index === firstIndex ? sameRoleRows.length : 0,
          },
        };
      },
    },
    {
      title: "Work Role Name",
      dataIndex: "role_name",
      width: 300,
      render: (val, row, index) => {
        const sameRoleRows = transformedData.filter(
          (item) => item.role_id === row.role_id && item.user_id === row.user_id
        );
        const firstIndex = transformedData.findIndex(
          (item) => item.role_id === row.role_id && item.user_id === row.user_id
        );

        return {
          children: <div className="ellipsis">{val}</div>,
          props: {
            rowSpan: index === firstIndex ? sameRoleRows.length : 0,
          },
        };
      },
    },
    {
      title: "Course ID",
      dataIndex: "course_id",
      width: 150,
      render: (val) => <span className="text-primary">{val}</span>,
    },
    {
      title: "Course Name",
      dataIndex: "course_name",
      width: 250,
      render: (val) => <div className="ellipsis">{val}</div>,
    },
  ];

  return (
    <CaSideNav props={CaAdminLearningMenu}>
      <SecondaryNav menuItems={LearningMatrixNav} />
      <CommonTopDetails
        title={`Learner Matrix Summary`}
        titleSuffix={`${itemsLength || 0} row(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={true}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => {},
        }}
      />
      <div className="matrix-container">
        <Table
          dataSource={transformedData}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          loading={loading}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={false}
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(29)}px`,
          }}
          style={{ margin: "1rem" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </CaSideNav>
  );
};

export default LearnerMatrix;
